import React, { useState, useEffect, useRef, useCallback  } from 'react';
import Logo from "../images/logo.svg";
import Select from 'react-select';
import Sidebar from '../component/Sidebar';
import { SelectPicker, Placeholder, Message ,Whisper, Tooltip, Popover, Button, Loader, Modal  } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import { Link, useNavigate } from "react-router-dom";
import * as bootstrap from 'bootstrap';
import { ReactComponent as IconStarOutline } from "../images/star-outline.svg";
import { ReactComponent as IconStar } from "../images/IconStar.svg";
import debounce from 'lodash.debounce';
import IconInfo from "../images/IconErrorInfo.svg";
import IconError from "../images/IconError.svg";
import IconCheckError from "../images/IconCheckError.svg";
import Open_Link_Icon from "../images/Open_link_round.svg";
import IconJson from "../images/IconJSONAction.svg";
import 'aos/dist/aos.css';
import AOS from 'aos';
import { Center } from '@chakra-ui/react';
import CheckIcon from '@rsuite/icons/Check';
import CloseIcon from '@rsuite/icons/Close';
import iconFinnhubUpload from "../images/icon-finnhub-upload.svg";
import iconFinnhub from "../images/iconFinnhub.svg";
import { motion, AnimatePresence } from 'framer-motion';
import Lottie from "lottie-react";
import animationData1 from '../lottie/1.json';
import animationData2 from '../lottie/2.json';
import animationData3 from '../lottie/3.json';
import animationData4 from '../lottie/4.json';
import animationData5 from '../lottie/5.json';
import animationData6 from '../lottie/6.json';
import { ChakraProvider, useToast, Wrap } from '@chakra-ui/react'
import IconReportAction from "../images/IconReportAction.svg";
const stepAnimations = {
  0: animationData1,
  1: animationData2,
  2: animationData3,
  3: animationData4,
  4: animationData5,
  5: animationData6
};

function CompanyProfile() {
  const [tabName, setTabName] = useState('ISRI Profile');
  useEffect(() => {
    document.title = tabName;
  }, [tabName]);


  useEffect(() => {
    AOS.init();
  }, []);
  const abortControllerRefGlobal = useRef(null);

  const cancelButtonRef = useRef(null);

  const [isLoading, setLoading] = useState(true); // State to manage loading state
  const navigate = useNavigate();
  const apiEndPoint = process.env.REACT_APP_API_ESG_ENDPOINT;
  const apiEndPoint1 = process.env.REACT_APP_API_ENDPOINT;
  const frontEndLink = process.env.REACT_APP_MUSAFFA_LINK;
  const roleName = localStorage.getItem("novaRolename");
  const merlinJuniorAnalyst = process.env.REACT_APP_MERLIN_JUNIOR_ANALYST;
  const abortControllerRef = useRef(null);

  const [reportData, setReportData] = useState([]);
  const [reportCount, setReportCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [startPage, setStartPage] = useState(1);
  const [countryCode, setCountryCode] = useState("");
  const [countryFinnhubCode, setCountryFinnhubCode] = useState("");
  const [complianceId, setComplianceId] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [pageRange, setPageRange] = useState("20");

  const [countryData, setCountryData] = useState([]);
  const [complianceData, setComplianceData] = useState([]);
  
  const [bothAnalystAssignData, setBothAnalystAssignData] = useState([]);
  const [analystId, setAnalystId] = useState("");
  const [selectedQuarter, setSelectedQuarter] = useState("");

  const userid = localStorage.getItem("novauserid");
  const progressStatus = process.env.REACT_APP_TASK_MANAGER_PROGRESS_Status;


  const [errorMessage, setErrorMessage] = useState('');
  const [messageType, setMessageType] = useState(null); // success, error, info


  const [exchangeData, setExchangeData] = useState([]);
  const [fetchCompanySymbol, setFetchCompanySymbol] = useState('');
  const [fetchCompanyExchange, setFetchCompanyExchange] = useState(null)


  const handleQuaterChange = (selectedOption) => {
    setSelectedQuarter(selectedOption); // Update selectedPeriod state with the selected option
  };

  //Country List
  useEffect(() => {
    const fetchCountryList = async () => {
      const url = ` ${apiEndPoint1}/get_country_list`;
      const payload = {
        data: {
          user_id: userid // Replace with the actual user_id if dynamic
        }
      };
  
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });
  
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
  
        const responseData = await response.json();
        const data = responseData.data; // Flatten the response

        const formattedCountryData = data.data.map((country) => ({
          label: country.country_name,
          value: country.country_code,
        }));

        setCountryData(formattedCountryData);
  
      } catch (error) {
        console.log(error);
      }
    };
  
    fetchCountryList();
  }, []);




  // Compliance List
  useEffect(() => {
    const fetchComplianceStatusList = async () => {
      const url = `${apiEndPoint1}/get_compliance_status`;
      const payload = {
        data: {
          user_id: userid // Replace with the actual user_id if dynamic
        }
      };
  
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });
  
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
  
        const responseData = await response.json();
        const data = responseData.data; // Flatten the response

        const formattedComplianceStatusData = data.data.map((complaince) => ({
          label: complaince.name,
          value: complaince.id,
        }));

        setComplianceData(formattedComplianceStatusData);
  
      } catch (error) {
        console.log(error);
      }
    };
  
    fetchComplianceStatusList();
  }, []);


   useEffect(() => {
      // Function to fetch data from the API
      const fetchData = async () => {
        try {
          const response = await fetch(
            `${apiEndPoint1}/get_user_lists`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                data: {
                  user_id: userid,
                },
              }),
            }
          );
  
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
  
          const responseData = await response.json();
          const data = responseData.data; // Flatten the response
  
          if (data.status === "success") {
            const formattedJuniorData = data.data.junior_data.map((user) => ({
              label: user.user_name,
              value: user.user_name,
              role: user.role_name.replace("MERLIN_", "").replace("_", " "),
              avatar: user.profile_img || "https://via.placeholder.com/30",
              userId: user.user_id,
            }));
  
            const formattedSeniorData = data.data.senior_data.map((user) => ({
              label: user.user_name,
              value: user.user_name,
              role: user.role_name.replace("MERLIN_", "").replace("_", " "),
              avatar: user.profile_img || "https://via.placeholder.com/30",
              userId: user.user_id,
            }));
  
            const formattedBothData = data.data.senior_junior_data.map(
              (user) => ({
                label: user.user_name,
                value: user.user_id,
                userId: user.user_id,
              })
            );
  
            // setJuniorAssignData(formattedJuniorData);
            // setSeniorAssignData(formattedSeniorData);
            setBothAnalystAssignData(formattedBothData);
          }
        } catch (error) {
          setErrorMessage(error.message);
          setMessageType('error');
          return false;
        }
      };
  
      fetchData();
    }, []);
  





    const fetchGlobalReport = async () => {
  
      setLoading(true);
  
      // Cancel the previous request if any
      if (abortControllerRefGlobal.current) {
        abortControllerRefGlobal.current.abort();
      }
  
       // Create a new AbortController for the current request
       const controller = new AbortController();
       abortControllerRefGlobal.current = controller;
  
  
      try {
      
        const apiUrl = `${apiEndPoint}/get_iri_reports`; 
        const requestData = {
          data: {
          user_id: userid,
          limit: pageRange,
          page: currentPage.toString(),
          sort_order: "desc",
          q: searchInput || "",
          country_code: countryCode || "",
          order_by:"updated_date",
          status:complianceId,
          analyst_id:analystId,
          }
        };
  
        //console.log(JSON.stringify(requestData));
  
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestData),
          signal: controller.signal
        });
        
        const jsonData = await response.json();
        if (jsonData.data.status === "success") {
          setLoading(false);
          setReportCount(jsonData.data.count);
          setReportData(jsonData.data.data);
        } else {
          setLoading(false);
          setErrorMessage(jsonData.data.message);
          setMessageType('error');
          return false;
        }
      } catch (error) {
        if (error.name === "AbortError") {
          console.log("GLobal Request cancelled");
        }
        else{
        setLoading(false);
        setErrorMessage(error.message);
        setMessageType('error');
      }
        return false;
      }
    };

  const debouncedFetchGlobalReport = useCallback(
    debounce(() => {
      fetchGlobalReport();
    }, 500),
    [searchInput] // Only debounce on search input changes
  );

  useEffect(() => {
    debouncedFetchGlobalReport();
    return () => {
      debouncedFetchGlobalReport.cancel();
    };
  }, [searchInput]);

  useEffect(() => {
    fetchGlobalReport();
  }, [currentPage, countryCode, complianceId,pageRange,analystId]); // Regular effect for other dependencies



  const data2 = [
    { label: "Report 1", value: 1 },
    { label: "Report 2", value: 2 },
    { label: "Report 3", value: 3 },
    { label: "Report 4", value: 4 },
  ];



const handleSearch = (event) => {
  console.log(event.target.value);

  setSearchInput(event.target.value);
  setCurrentPage(1); // Reset to the first page for new search
};


const handleCountryChange = (value) => {
  setCountryCode(value);
};

const handleComplianceChange = (value) => {
  setComplianceId(value);
};



const handleAddNewReport = async (item) => {
     
       if (toastIdRef.current && toast.isActive(toastIdRef.current)) {
                toast.close(toastIdRef.current);
            }
  if(!reportSource)
    {
      toastIdRef.current = toast({ description: "Please Enter Report Number", status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
      return false;
    }


  try {
    const response = await fetch(`${apiEndPoint}/create_iri_task`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        data: {
          user_id: userid,
          company_symbol: item.stock_name,
          main_ticker: item.main_ticker,
          exchange: item.exchange,
          report_no:reportSource,
        }
      })
    });

    const result = await response.json();
    if (result?.data?.status === 'success') {
        cancelButtonRef.current?.click();
        navigate(`/IRIReport/${result.data.encryptJSON}`);

    } else {
      console.error("API call failed:", result);
      toastIdRef.current = toast({ description: result?.data?.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
    }
  } catch (error) {
    console.error("Error:", error);
    toastIdRef.current = toast({ description: "Something Went Wrong", status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
  }
  };








const [customPaginationValue, setCustomPaginationValue] = useState("");

// Debounced function to update the page number
const debouncedSetPage = useCallback(
  debounce((page) => {
    setCurrentPage(page);
  }, 500), // Delay of 500ms (half a second)
  []
);

const handlePaginationChange = (e) => {
  const value = (e.target.value == 0 ? 1 : e.target.value).toString() ;
  setCustomPaginationValue(value); // Update input value immediately for fast typing
  debouncedSetPage(Number(value)); // Trigger the debounced function
};

const handlePagelimit = (value) => {
  setCurrentPage(1);
  setCustomPaginationValue(1);
  setPageRange(value); 
};


const renderPagination = () => {
  // Calculate total number of pages
  const totalPages = Math.ceil(reportCount / pageRange);

  // Show a default of 3 pages if the total pages are more than 3
  const pageNumbers = [];
  const visiblePageCount = 4; // Number of pages to show by default

  let startPage = currentPage - 1;
  let endPage = currentPage + 2;

  // Adjust pagination if total pages are less than the default
  if (totalPages <= visiblePageCount) {
    startPage = 1;
    endPage = totalPages;
    
  } else {
    
    // Ensure the pagination does not go out of bounds
    startPage = Math.max(1, startPage);
    endPage = Math.min(totalPages, endPage);
  }

  // Create page numbers to display based on current page
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  return (
    <nav aria-label="..." id='pagination_row' style={{alignItems:'center', justifyContent:'space-between', background:'#FFF', paddingTop:0, paddingBottom:0}}>
      <div className='totalRecords'>
        Total Records :  {Number(reportCount).toLocaleString()}
      </div>
      <ul className="pagination" style={{border: 0, background: 'none'}}>

      <li class="page-item" style={{marginLeft:10}}>
                    <SelectPicker onChange={handlePagelimit} cleanable={false}
                    value={pageRange} 
                    placement="top" placeholder='Pages' data={PagingData} searchable={false} style={{ width: 85, height:35, display:'flex', alignItems:'center', borderRadius: 5, border: '1px solid #A1B9ED'}} />
                  </li>

        {/* Previous Page (Double Arrow) */}
        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`} style={{marginLeft: 10}}>
          <a href="#" className="page-link" onClick={() => setCurrentPage(1)}>
            <i className="fa fa-angle-double-left"></i>
          </a>
        </li>

        {/* Previous Page (Single Arrow) */}
        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
          <a href="#" className="page-link" onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}>
            <i className="fa fa-angle-left"></i>
          </a>
        </li>

        {/* Page numbers */}
        {pageNumbers.map(page => (
          <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
            <a 
              className="page-link" href="#" 
              onClick={() => setCurrentPage(page)} // Set the clicked page as the current page
            >
              {page}
            </a>
          </li>
        ))}
        
        {/* Next Page (Single Arrow) */}
        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
          <a href="#" className="page-link" onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}>
            <i className="fa fa-angle-right"></i>
          </a>
        </li>

        {/* Next Page (Double Arrow) */}
        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`} style={{marginRight: 10}}>
          <a href="#" className="page-link" onClick={() => setCurrentPage(totalPages)}>
            <i className="fa fa-angle-double-right"></i>
          </a>
        </li>
        
        {/* Go to Page */}
        <li className="page-item" style={{marginLeft: 10, display: 'flex', alignItems: 'center', gap: 5}}>
          <input
            type="text"
            placeholder="Go#"
            className="form-control"
            value={customPaginationValue}
            onChange={handlePaginationChange}
            onInput={(e) => {
              // Only allow numbers
              e.target.value = e.target.value.replace(/[^0-9]/g, '');
            }}
          
            style={{
              padding: '0px 10px', 
              color: '#878787', 
              fontSize: 16, 
              borderRadius: 5, 
              border: '1px solid #A1B9ED', 
              width: 60, 
              height: 35, 
              textAlign: 'center'
            }}
          />
        </li>
      </ul>
    </nav>
  );
};





// PAGINATION
const PagingData = ['10', '20', '50', '100'].map(
item => ({ label: item, value: item })
);



const handleClearFilters = () => {
  setCurrentPage(1);
  setCountryCode("");
  setSearchInput("");
  setComplianceId("");
  setAnalystId("");
};




const hideMessage = () => {
  setMessageType(null);
};

const renderMessage = () => {
  if (messageType) {
    setTimeout(hideMessage, 4000);
  };

  switch (messageType) {
    case 'success':
      return (
        <Message type="success" closable style={{ display: 'flex', alignItems: 'center', width: 'auto', position:"fixed", right:10, top:10, zIndex: 99999}}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
            <div className='icon_error_msg Icon_success'>
              <div className='icon_error_msg_inner Icon_success_inner'>
                <img src={IconCheckError} alt="Success Icon" />
                <div className="progress-circle progress_circle_success"></div>
              </div>
            </div>
            <div className='error_msg_text error_msg_success_text'>
              <h5>Success</h5>
              <p>{errorMessage}</p>
            </div>
          </div>
        </Message>
      );
    case 'error':
      return (
        <Message type="error" closable style={{ display: 'flex', alignItems: 'center', width: 'auto',  position:"fixed", right:10, top:10, zIndex: 99999}}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
            <div className='icon_error_msg Icon_error'>
              <div className='icon_error_msg_inner Icon_error_inner'>
                <img src={IconError} alt="Error Icon" />
                <div className="progress-circle progress_circle_error"></div>
              </div>
            </div>
            <div className='error_msg_text error_msg_error_text'>
              <h5>Error</h5>
              <p>{errorMessage}</p>
            </div>
          </div>
        </Message>
      );
      case 'info':
      return (
        <Message type="info" closable style={{ display: 'flex', alignItems: 'center', width: 'auto',  position:"fixed", right:10, top:10, zIndex: 99999}}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
            <div className='icon_error_msg Icon_info'>
              <div className='icon_error_msg_inner Icon_info_inner'>
                <img src={IconInfo} alt="Info Icon" />
                <div className="progress-circle progress_circle_info"></div>
              </div>
            </div>
            <div className='error_msg_text error_msg_info_text'>
              <h5>Info</h5>
              <p>No reports found for the selected priority</p>
            </div>
          </div>
        </Message>
      );
      default:
        return null;
  }
};



const [publishSymbol, setPublishSymbol] = useState("");


  

  const handleCheckboxChange = (e, item) => {
    setPublishSymbol(item.company_symbol)
    //e.stopPropagation(); // Prevents the event from bubbling up
    // Handle the checkbox change here
    // You can check e.target.checked to see if it's checked or unchecked
};


const toast = useToast()
const toastIdRef = React.useRef()

 // FETCH FINNHUB 
 const [failedStep, setFailedStep] = useState(null);
 const [currentStep, setCurrentStep] = useState(-1);
 const [completedSteps, setCompletedSteps] = useState([]);
 const [loading2, setLoading2] = useState(false);
 const [missingFields, setMissingFields] = useState([]);

 const steps = [
   'Getting Data from Finnhub',
   'Storing in the Database',
   'Data Cleaning',
   'Validating Data...',
   'Added to Production',
   'Company Data Successfully Pushed to Typesense'
 ];

 const stepsConfig = [
  {
    label: 'Getting Data from Finnhub',
    // action: async () => {
    //   const response = await fetch(`${apiEndPoint}/addnewcompany_finhub`, {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify({
    //       data: {
    //         user_id: userid,
    //         exchange: fetchCompanyExchange, // dynamic exchange value
    //         company_symbol: fetchCompanySymbol // dynamic company symbol
    //       }
    //     })
    //   });
    //   const result = await response.json();
    //   if (!response.ok || result?.success === false) {
    //     throw new Error(result?.message || 'Failed at step: Getting Data from Finnhub');
    //   }
    // }
    action: async () => {
      // Replace with your next API call
      await new Promise(resolve => setTimeout(resolve, 1000)); // simulate success
    }
  },
  {
    label: 'Storing in the Database',
    action: async () => {
      // Replace with your next API call
      await new Promise(resolve => setTimeout(resolve, 1000)); // simulate success
    }
  },
  {
    label: 'Data Cleaning',
    action: async () => {
      const response = await fetch(`${apiEndPoint}/clean_company_profile`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          data: {
            user_id: userid, // dynamic
            company_symbol: fetchCompanySymbol // dynamic
          }
        })
      });
      const result = await response.json();
      if (!response.ok || result?.success === false) {
        throw new Error(result?.message || 'Failed at step: Data Cleaning');
      }

      if (result?.data?.status === 'warning') {
        setMissingFields(result?.data?.missing_fields || []);
        throw new Error('Some fields are missing');
      }

    }
  },
  {
    label: 'Validating Data...',
    action: async () => {
      await new Promise(resolve => setTimeout(resolve, 1000));
      // Replace with your next API call
      //throw new Error('Validation failed'); // simulate failure
    }
  },
  {
    label: 'Added to Production',
    action: async () => {
      const response = await fetch(`${apiEndPoint}/addtoprod_companyprofile`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          data: {
            company_symbol: fetchCompanySymbol // dynamic
          }
        })
      });
      const result = await response.json();
      if (!response.ok || result?.success === false) {
        throw new Error(result?.message || 'Failed at step: Added to Production');
      }
    }
  },
  {
    label: 'Company Data Successfully Pushed to Typesense',
    action: async () => {
      await new Promise(resolve => setTimeout(resolve, 1000));
    }
  }
];


const [currentAnimation, setCurrentAnimation] = useState(animationData1);
const animationMap = [
  animationData1,
  animationData2,
  animationData3,
  animationData4,
  animationData6,
  animationData6
];

const handleFinnhubCountryChange = (value) => {
  setCountryFinnhubCode(value);
};

const handleAdd = async () => {
  let hasError = false;

  if (!fetchCompanySymbol.trim()) {
    toastIdRef.current = toast({
      description: "Company symbol is required",
      status: 'error',
      duration: 5000,
      isClosable: true,
      position: 'bottom',
    });
    hasError = true;
  }

  if (!fetchCompanyExchange) {
    toastIdRef.current = toast({ description: "Exchange selection is required", status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
    hasError = true;
  }

  if (hasError) return;

  setLoading2(true);
  setCompletedSteps([]);
  setCurrentStep(0);
  setFailedStep(null);

  for (let i = 0; i < stepsConfig.length; i++) {
    setCurrentStep(i);
    setCurrentAnimation(animationMap[i]);
    
    try {
      await stepsConfig[i].action(); // execute API or step
      setCompletedSteps((prev) => [...prev, i]);
    } catch (error) {
      console.error(`Step "${stepsConfig[i].label}" failed:`, error.message);
      setFailedStep(i);
      setCurrentAnimation(animationData5);
      setLoading2(false);
      return;
    }
  }

  setLoading2(false);
  setCurrentStep(-1);
};


 const renderIcon = (index) => {
   if (failedStep === index) {
     return <CloseIcon style={{ color: '#DA293E', marginRight: '8px', width: 13 }} />;
   } else if (completedSteps.includes(index)) {
     return <CheckIcon style={{ color: '#0A8F43', marginRight: '8px', width: 13 }} />;
   } else if (loading2 && currentStep === index) {
     return <Loader size="xs" style={{ marginRight: '8px', width: 13 }} />;
   } else {
     return (
       <span
         style={{
           width: '8px',
           height: '8px',
           borderRadius: '50%',
           backgroundColor: '#878787',
           marginTop: 5,
           display: 'inline-block',
           marginRight: '10px'
         }}
       />
     );
   }
 };

 const [showTooltip, setShowTooltip] = useState(window.innerWidth < 1500);

 useEffect(() => {
   const handleResize = () => {
     setShowTooltip(window.innerWidth < 1500);
   };

   window.addEventListener('resize', handleResize);
   return () => window.removeEventListener('resize', handleResize);
 }, []);

 function getIriScoreClass(score) {
  if (score >= 0 && score < 1) return 'status__task__poor';
  if (score >= 1 && score < 2) return 'status__task__weak';
  if (score >= 2 && score < 3) return 'status__task__fair';
  if (score >= 3 && score < 4) return 'status__task__good';
  if (score >= 4 && score <= 5) return 'status__task__exc';
  return ''; // fallback if out of range
}

const [editModalData, setEditModalData] = useState([]);

const handleReportData = (item) => {       
    setEditModalData(item);    
    setReportSource("");    
}

const [reportSource, setReportSource] = useState('');

const handleChange = (e) => {
  const value = e.target.value;
  // Allow only digits (any length)
  if (/^\d*$/.test(value)) {
    setReportSource(value);
  }
};

 const handleAnalystChange = (value) => {    
    setAnalystId(value);
  };

  
  return (
    <>
      <Sidebar />
       <ChakraProvider></ChakraProvider>
      <div id='header'>
        <div className='logo'>
          <div className='logo_icon'>
            <img src={Logo} alt="Logo" />
          </div>
          <div className='brand_name'>ISRI Profile</div>
        </div>

        <div className='header_table_filter'>
          <div className='searchfield'>
            <button className='btn_search'><i className='icon-search2'></i></button>
            <input type='text' className='filter_searchfield' placeholder='Search' autocomplete="off"  onChange={handleSearch}   value={searchInput}/>
          </div>


          <div className='dropdown_col_filter dropdown__select'>
          <SelectPicker
              data={countryData}
              searchable={true}
              style={{width:200}}
              placeholder="Country"
              onChange={handleCountryChange}
              value={countryCode}
            />
          </div>
          
          <div className='dropdown_col_filter dropdown__select'>
            <SelectPicker
              data={complianceData}
              searchable={false}
             
              placeholder="Select Compliance"
              onChange={handleComplianceChange}
              value={complianceId}
            />
          </div>

            
           <div className="dropdown_style">
                      <SelectPicker
                        data={bothAnalystAssignData}
                        searchable={true}
                        style={{width:200}}
                        placeholder="Filter by Analyst Name"
                        onChange={handleAnalystChange}
                        value={analystId}
                      />
                    </div>


          <a href="javascript:void(0)" className="btn_clear_filter" style={{textDecoration:"none"}} onClick={handleClearFilters}>
            Clear Filters
          </a>
        </div>
      </div>
      <div className="container-fluid content pb-5">
        <div className='company_table_list' data-aos="fade-up" data-aos-duration="600">
        {isLoading && ( <Placeholder.Grid rows={20} columns={9} active style={{paddingLeft:20, paddingRight:20, paddingTop:12}} /> )}

{/* Table */}
{!isLoading && (
<>
          <div className='table-responsive clsPagingWrap' >
            <table className='table'>
              <thead>
                <tr>
                  <th>Ticker and Stock Name</th>
                  <Whisper placement="top" controlId="control-id-hover" trigger="hover"  speaker={<Tooltip>Combined Country and Exchange information</Tooltip>}> 
                  <th style={{cursor:'pointer'}}>Country</th>
                  </Whisper>
                  <th>Compliance</th>
                 
                  <th>published By</th>
                  <th>Publish Date</th>
                  <th>Quater</th>
                  <th style={{textAlign:'right'}}>Actions</th>
                </tr>
              </thead>
              <tbody>
              {reportData.length > 0 ? (
  reportData.map((company, index) => (
                  <tr key={index}>
                    <td>
                      <div className='company_name_td'>
                        <span className='company_lable' style={{width:115}}>{company.stock_name}</span>
                        <div className="clogo">
                    <img src={company.logo} />
                  </div>
                        {company.company_name}
                      </div>
                    </td>
                    <td>{company.country} - {company.exchange}</td>
                   
                    <td>
                    {company.sharia_status != null &&
                        <span className={`tag_td ${ company.sharia_status == "0" || company.sharia_status == null ? '' : company.sharia_status == "CMPT" ? 'halal_tag' : company.sharia_status == "NCMPT" ? 'not_halal_tag' : company.sharia_status == "DBTF" ? 'doughtful_tag' : company.sharia_status == "UNCV" ? 'uncover_tag' : 'doubtful_tag' }`} style={{width:75}}>
                       
                       {company.sharia_status}
                        </span>
                    }
                    </td>
                    <td>
                    {company.published_by}
                    </td>
                    <td>{company.publish_date}</td>
                   <td>{'Q'+ company.quarter +'-'+ company.year}</td>
                     <td>
                  <div className='action_row' style={{justifyContent:'flex-end'}}>
                    <h5> <Link className='btn_create_report' data-bs-toggle="modal" data-bs-target={`#CreateReportModal`} onClick={() => handleReportData(company)} > Create Report </Link> </h5>
                  </div>
                </td>

           

                  </tr>



                ))
              ) : (
                <tr>
                  <td colSpan="9" style={{ textAlign: "center" }}>
                    No data available
                  </td>
                </tr>
              )}
              </tbody>
            </table>
          </div>

          {reportCount > 0 && renderPagination()}

        </>    
)}
        </div>
      </div>

               {/* Modal */}
     <div className="modal fade duplicate_form_modal" id={`CreateReportModal`} taAbIndex="-1" aria-labelledby={`DuplicateFormModalLabel`} aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered" style={{maxWidth:360}}>
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5">{editModalData.company_name}</h1>
          </div>
          <div className="modal-body">
            <div className='duplicate_form_content' style={{paddingTop:0}}>
              <div className='duplicate_form_row' style={{flexDirection:'column'}}>
                <div style={{width:'100%',textAlign:'right'}}>
                  <span>{editModalData.quarter}-{editModalData.year}</span>
                </div>
               
                <div className='duplicate_form_col' style={{width:'100%'}}>
                  <label>Report</label>
                  <input type='text' id="reportSource" className='form-control' placeholder='Report Number' value={reportSource} onChange={handleChange} />
                </div>

              </div>

              <div className="btn__group">
                <button type="button" className="btn_cancel" data-bs-dismiss="modal" id={`Cancel`}  ref={cancelButtonRef}>Cancel</button>
                <button type="button" className="btn_duplicate btn_add_new_report" onClick={() => handleAddNewReport(editModalData)}>Add New Report</button>
                {/* <button type="button" className="btn_duplicate btn_add_new_report" onClick={() => handleAddNewReport(company.row_id)}>Add New Report</button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
     </div>

    {/* End Modal */}


    

    </>
  );
}

export default CompanyProfile;
